import Wallet from '@/pages/Wallet/index.vue';
import ServiceAvailability from '@/pages/ServiceAvailability/index.vue';
import SettingsLayout from '@/pages/Layout/SettingsLayout.vue';
import Overview from '@/pages/Overview.vue';
import Orders from '@/pages/Orders/index.vue';
import Customers from '@/pages/Customers/index.vue';
import CustomersProfile from '@/pages/Customers/Profile/index.vue';
import CustomersAccounts from '@/pages/Customers/Profile/accounts.vue';
import CustomersOrders from '@/pages/Customers/Profile/orders.vue';
import VirtualAccounts from '@/pages/Account/index.vue';
// Settings
import Developer from '@/pages/Settings/Developer/index.vue';
import Notification from '@/pages/Settings/Notification/index.vue';
import WebHook from '@/pages/Settings/Webhook/index.vue';
import UpdateBusinessProfile from '@/pages/Settings/UpdateBusinessProfile.vue';
import TeamAccess from '@/pages/Settings/TeamAccess/index.vue';
// import BusinessConfig from '@/pages/Settings/BusinessConfig/index.vue';

import Profile from '@/pages/PersonalProfile/index.vue';
import Businesses from '@/pages/Businesses.vue';
import WebhookHistory from '@/pages/Settings/Webhook/History';
// import Test from '@/pages/Test.vue';
import BatchOrder from '@/pages/BatchOrder/index.vue';
import ReportsList from '@/pages/Reports/List.vue';

export const customersProfileRoutes = [
  {
    path: 'details',
    name: 'Details',
    component: CustomersProfile,
    meta: {
      resources: ['customers'],
      requireAuth: false,
      label: 'Customers Profile',
    },
  },
  {
    path: 'accounts',
    name: 'Virtual Accounts',
    component: CustomersAccounts,
    resources: ['customers'],
    meta: {
      resources: ['customers'],
      requireAuth: true,
      label: 'Virtual Accounts',
    },
  },
  {
    path: 'transaction',
    name: 'Transactions',
    component: CustomersOrders,
    resources: ['customers'],
    meta: {
      resources: ['customers'],
      requireAuth: true,
      label: 'Transactions',
    },
  },
];

export const sidemenu = [
  {
    path: '/',
    label: 'Overview',
    icon: 'home',
    resources: ['dashboard'],
    meta: {
      resources: ['dashboard'],
      requireAuth: false,
      label: 'Overview',
    },

    component: Overview,
  },
  // {
  //   path: '/test',
  //   label: 'Test',
  //   icon: 'home',
  //   resources: ['test'],
  //   meta: {
  //     resources: ['test'],
  //     requireAuth: false,
  //     label: 'Test',
  //   },

  //   component: Test,
  // },
  {
    path: '/orders',
    label: 'Orders',
    icon: 'sell',
    resources: ['orders'],
    meta: {
      resources: ['orders'],
      requireAuth: true,
      label: 'Orders',
    },
    component: Orders,
  },
  {
    path: '/batch-order',
    label: 'Batch Order',
    icon: 'money',
    meta: {
      resources: ['batch-order'],
      requireAuth: true,
      label: 'Batch Order',
    },
    component: BatchOrder,
  },
  {
    path: '/virtual-account',
    label: 'Virtual Accounts',
    icon: 'account_balance',
    resources: ['customers'],
    meta: {
      resources: ['customers'],
      requireAuth: true,
      label: 'Virtual Account',
    },
    component: VirtualAccounts,
  },
  {
    path: '/customers',
    label: 'Customers',
    icon: 'people',
    resources: ['customers'],
    meta: {
      resources: ['customers'],
      requireAuth: true,
      label: 'Customers',
    },
    component: Customers,
  },
  {
    path: '/wallet',
    label: 'Wallet',
    icon: 'money',
    resources: ['wallet'],
    meta: {
      resources: ['wallet'],
      requireAuth: true,
      label: 'Wallet',
    },
    component: Wallet,
  },
  {
    path: '/reports',
    label: 'Reports',
    icon: 'description',
    // No 'reports' key exists in the ACL response yet, so this stays
    // requireAuth: false (like Settings/Overview) rather than being hidden
    // for everyone until that's added on the backend.
    meta: {
      resources: ['reports'],
      requireAuth: true,
      label: 'Reports',
    },
    component: ReportsList,
  },
  {
    path: '/settings',
    label: 'settings',
    icon: 'settings',
    meta: {
      resources: ['settings'],
      requireAuth: false,
      label: 'Settings',
    },
    component: SettingsLayout,
  },
  {
    path: '/service-availability',
    label: 'Service Availability',
    icon: 'monitor_heart',
    meta: {
      resources: ['settings'],
      requireAuth: true,
      label: 'Service Availability',
    },
    component: ServiceAvailability,
  },
];

export const profileRoutes = [
  {
    path: '', component: Profile, name: 'Profile', label: 'Profile',
  },
  { path: 'businesses', component: Businesses, name: 'Switch Business' },
];

export const settingsRoutes = [
  {
    path: '',
    name: 'Profile',
    component: UpdateBusinessProfile,
    meta: {
      resources: ['business'],
      requireAuth: false,
      label: 'Profile',
    },
  },
  {
    path: 'team-access',
    name: 'Team Access',
    component: TeamAccess,
    resources: ['team-access'],
    meta: {
      resources: ['team-access'],
      requireAuth: true,
      label: 'Team Access',
    },
  },

  {
    path: 'developer',
    name: 'API Keys',
    component: Developer,
    resources: ['developer'],
    meta: {
      resources: ['api-credentials'],
      requireAuth: true,
      label: 'Developer',
    },
  },
  {
    path: 'webhook',
    name: 'Webhook',
    icon: 'settings',
    component: WebHook,
    resources: ['webhook'],
    meta: {
      resources: ['webhook'],
      requireAuth: true,
      label: 'Webhook',
    },
  },
  {
    path: 'notification',
    name: 'Notifications',
    component: Notification,
    resources: ['notification'],
    meta: {
      resources: ['notification'],
      requireAuth: true,
      label: 'Notification',
    },
  },
  {
    path: 'event',
    name: 'Event Logs',
    icon: 'settings',
    component: WebhookHistory,
    resources: ['webhook'],
    meta: {
      resources: ['webhook'],
      requireAuth: true,
      label: 'Webhook',
    },
  },
  // {
  //   path: 'business-config',
  //   name: 'Business Config',
  //   icon: 'settings',
  //   component: BusinessConfig,
  //   resources: ['business-config'],
  //   meta: {
  //     resources: ['business-config'],
  //     requireAuth: false,
  //     label: 'Business Config',
  //   },
  // },
];

export const appName = 'Console';
